<script>
  import Dignitary from "./Dignitory.svelte"
  import Organiser from "./Organiser.svelte"
</script>

<section id="dignitaries">
  <i class="fas speaker-icon fa-user-tie text-center"></i>
  <h2 class="section-heading">dignitaries</h2>
  <section class="section-team">
      <div class="container">
        <div class="row ">
          <Dignitary name="Dr. G. Aghila" position="Director, NIT Trichy
          Conference Patron" img="./images/director.jpg"/>
          <Dignitary name="Prof. B. Ravisankar" position="Head, Dept of Metallurgical & Materials Engineering
          Conference Co-patron" img="./images/ravisankar.jpg"/>
          <Dignitary name="Dr.  K. Sivaprasad" position="Dept of MME, NIT Trichy
          Conference Chairman" img="./images/shivaprasad.jpg"/>
          <Dignitary name="Prof. Filippo Berto" position="NTNU, Norway
          Conference Chairman" img="./images/filippo.jpg"/>
          <Dignitary name="Prof. –Ing. K.G. Prashanth" position="Tallinn University, Estonia
          Conference Chairman" img="./images/Prashanth.jpg"/>
          <Dignitary name="Dr. N. Ramesh Babu" position="Dept of MME, NIT Trichy
          Conference Chairman" img="./images/ramesh.jpg"/>
          <Dignitary name="Dr. Prince Gideon" position="Dept of MME, NIT Trichy
          Conference Secretary" img="./images/Prince.jpg"/>
          <Dignitary name="Dr. S. Jerome" position="Dept of MME, NIT Trichy
          Conference Convener" img="./images/faculty/jerome.jpg"/>

        </div>
        <h2 class="section-heading mt-3">organisers</h2>
        <div class="row">
          <Organiser name="Dr. T. Srinivasa Rao" position="Dept of MME" img="./images/faculty/rao.jpg"/>
          <Organiser name="Dr. S. Raman Sankaranarayanan" position="Dept of MME" img="./images/faculty/raman.jpg"/>
          <Organiser name="Dr. S. Kumaran" position="Dept of MME" img="./images/faculty/kumaran.jpg"/>
          <Organiser name="Dr. S. P. Kumaresh Babu" position="Dept of MME" img="./images/faculty/kumaresh.jpg"/>
          <Organiser name="Dr. S. Muthukumaran" position="Dept of MME" img="./images/faculty/muthu.jpg"/>
          <Organiser name="Dr. D. Nagarajan" position="Dept of MME" img="./images/faculty/nagarajan.jpg"/>
          <Organiser name="Dr. V. Karthik" position="Dept of MME" img="./images/faculty/karthik.jpg"/>
          <Organiser name="Dr. Nimu Chand Reger" position="Dept of MME" img="./images/faculty/Nimu.jpg"/>
          <Organiser name="Dr. A. Muthuchamy" position="Dept of MME" img="./images/faculty/Muthuchamy.jpg"/>
          <Organiser name="Bestin B Thomas" position="Student, Dept of MME" img="./images/faculty/bestin_b_thomas.jpg" web={true}/>
        </div>
      </div>
  </section>
</section>

<style>
  section {
    padding-top: 86px;
    text-align: center;
  }
  h2 {
    text-align: center;
  }
  p {
    text-align: center;
    width: 80%;
    margin: 0 auto;
    font-size: 1.1em;
  }

  @media all and (min-width: 768px) {
    p {
      width: 60%;
    }
  }
  p,a,h1,h2,h3,h4 {
  margin: 0;
  padding: 0;
}
i {
    display: block;
    margin: 0 auto;
    font-size: 2rem;
    padding-bottom: 1em;
  }
.section-team {
  font-family: "Poppins", sans-serif;
  padding: 80px 0;
}
.section-team .header-section {
  margin-bottom: 50px;
}

.section-team .header-section .small-title {
    margin-bottom: 25px;
  font-size: 16px;
    font-weight: 500;
    color: #3e64ff;
}

.section-team .header-section .title {
    font-weight: 700;
    font-size: 45px;
}


</style>
